<template>
<!-- App.vue -->

<v-app>
    <v-app-bar
      color="deep-purple accent-4"
      dark
      app
    >
      <v-toolbar-title>Circus Citroen</v-toolbar-title>
    </v-app-bar>
  <!-- Sizes your content based upon application components -->
  <v-content app>

    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <!-- If using vue-router -->
      <router-view></router-view>
    </v-container>
  </v-content>
  <v-bottom-navigation
    grow
    app
  >
    <v-btn to="/list">
      <span>Ticket list</span>
      <v-icon>mdi-format-list-checks</v-icon>
    </v-btn>

    <v-btn to="/scanner">
      <span>Scan tickets</span>
      <v-icon>mdi-qrcode-scan</v-icon>
    </v-btn>

    <v-btn to="/history">
      <span>History</span>
      <v-icon>mdi-history</v-icon>
    </v-btn>
  </v-bottom-navigation>
</v-app>
</template>

<script>
//import Scanner from './components/Scanner';

export default {
  name: 'App',
  components: {
    //Scanner,
  },
  data: () => ({
    //
  }),
};
</script>
<style>
.v-bottom-navigation--fixed {position: fixed !important;}

.v-item-group.v-bottom-navigation .v-btn {height: inherit !important;}
</style>`